import { Injectable, inject } from '@angular/core';
import { NavigationSkipped, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private router = inject(Router);

  private history: string[] = [];
  private readonly storageKey = 'navigationHistory';

  constructor() {
    // 从 sessionStorage 恢复历史记录
    const savedHistory = sessionStorage.getItem(this.storageKey);
    this.history = savedHistory ? JSON.parse(savedHistory) : [];

    // 监听路由变化，记录历史
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationSkipped) {
        this.addToHistory(event.url);
      }
    });
  }

  // 添加到历史记录并同步到 sessionStorage
  private addToHistory(url: string): void {
    const lastUrl = this.history[this.history.length - 1];
    if (url !== lastUrl) {
      this.history.push(url);
      sessionStorage.setItem(this.storageKey, JSON.stringify(this.history));
    }
  }

  // 获取上一级路由
  getPreviousUrl(): string | null {
    if (this.history.length > 1) {
      return this.history[this.history.length - 2]; // 倒数第二个是上一级路由
    }
    return null;
  }

  // 返回上一级路由
  navigateBack(): void {
    const previousUrl = this.getPreviousUrl();
    if (previousUrl) {
      this.history.pop(); // 移除当前路由
      sessionStorage.setItem(this.storageKey, JSON.stringify(this.history)); // 更新存储
      this.router.navigateByUrl(previousUrl);
    } else {
      this.router.navigate(['/']); // 如果没有上一级，跳转到首页或其他默认路由
    }
  }

  // 清空历史记录（可用于注销或特定操作）
  clearHistory(): void {
    this.history = [];
    sessionStorage.removeItem(this.storageKey);
  }
}
